module.exports = __webpack_public_path__ + "assets/img/nodata.8c51edd4.png";